import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { PickerProfileManagementContent } from './Components/PickerProfileManagementContent';
import { NotificationStrategyProvider } from 'src/ZoneManagement/Providers/NotificationStrategyProvider';

export const PickerProfileManagement = (): React.JSX.Element => (
  <Page title="Picker Profiles" accessKey={'pickerProfiles'} isSearchable={true}>
    <NotificationStrategyProvider>
      <PickerProfileManagementContent />
    </NotificationStrategyProvider>
  </Page>
);
